export type SolicitationEvidenceContext = 'ABERTURA' | 'RESOLUCAO';

export type SolicitationEvidenceResponse = {
    id: string;
    solicitationId: string;
    fileName: string;
    fileUrl: string;
    fileSizeBytes: string | null;
    mimeType: string | null;
    uploadedAt: string;
    uploadedBy: string | null;
    context?: SolicitationEvidenceContext;
};

export type SolicitationEvidenceProps = {
    id: string;
    solicitationId: string;
    fileName: string;
    fileUrl: string;
    fileSizeBytes: string | null;
    mimeType: string | null;
    uploadedAt: string;
    uploadedBy: string | null;
    context: SolicitationEvidenceContext;
};

export class SolicitationEvidenceModel {
    private constructor(private readonly props: SolicitationEvidenceProps) {}

    public static with(props: SolicitationEvidenceProps): SolicitationEvidenceModel {
        return new SolicitationEvidenceModel(props);
    }

    public static withFromResponse(response: SolicitationEvidenceResponse): SolicitationEvidenceModel {
        return SolicitationEvidenceModel.with({ ...response, context: response.context ?? 'ABERTURA' });
    }

    public static withFromResponseList(list: SolicitationEvidenceResponse[]): SolicitationEvidenceModel[] {
        return list.map(SolicitationEvidenceModel.withFromResponse);
    }

    public get id(): string {
        return this.props.id;
    }

    public get solicitationId(): string {
        return this.props.solicitationId;
    }

    public get fileName(): string {
        return this.props.fileName;
    }

    public get fileUrl(): string {
        return this.props.fileUrl;
    }

    public get fileSizeBytes(): string | null {
        return this.props.fileSizeBytes;
    }

    public get mimeType(): string | null {
        return this.props.mimeType;
    }

    public get uploadedAt(): string {
        return this.props.uploadedAt;
    }

    public get uploadedBy(): string | null {
        return this.props.uploadedBy;
    }

    public get context(): SolicitationEvidenceContext {
        return this.props.context;
    }

    public isResolutionContext(): boolean {
        return this.props.context === 'RESOLUCAO';
    }

    public toObject(): SolicitationEvidenceProps {
        return { ...this.props };
    }
}
